import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Input,
  ModalHeader,
  ModalBody,
  Label,
  ModalFooter,
  Modal,
  Form,
  Alert 
} from "reactstrap";
import { useFeira } from "../Contexts/FeiraContext";
import InputMask from 'react-input-mask';

function ModalDeReserva() {
  const {
    openModal,
    setOpenModal,
    data,
    formaPagamentoId,
    setFormaPagamentoId,
    condicaoPagamentoId,
    setCondicaoPagamentoId,
    observacao,
    setObservacao,
    cnpjCi,
    setCNPJCi,
    nome,
    setNome,
    email,
    setEmail,
    telefone,
    setTelefone,
    setLogo,
    handleConfirmarReserva,
    erroCampoVazio,
    setErroCampoVazio,
    selectedEstandeInfo,
    endereco,
    setEndereco,
    estado,
    setEstado,
    cep,
    setCep,
    cidade,
    setCidade,
    termos,
    setTermos,
    showModalConfirmado,
    contrato,
    isLoading,
    limparCampos,
    paises,
    setComercialId,
    comercialId,
    pais,
    setPais,
    exibirAviso
  } = useFeira();

  const [openModalTermos, setOpenModalTermos] = useState(false);
  const [isBrasil, setIsBrasil] = useState(false);
  const [errors, setErrors] = useState({});

  const feiraDados = data?.retorno?.dados || {};
  const formasPagamento = feiraDados.formas_pagamento || [];
  const condicoesPagamento = feiraDados.condicoes_pagamento || [];
  
  const comerciaisOriginais = selectedEstandeInfo?.comercial || [];

  const comerciaisUnicosMap = new Map();

  comerciaisOriginais.forEach(item => {
    if (!comerciaisUnicosMap.has(item.id)) {
      comerciaisUnicosMap.set(item.id, item);
    }
  });

  const comerciais = Array.from(comerciaisUnicosMap.values());

  const handleOpenTermos = () => {
    if (nome && cnpjCi && selectedEstandeInfo?.nome) {
      setOpenModalTermos(true);
    } else {
      setErroCampoVazio("Por favor, preencha os campos obrigatórios (Nome, CNPJ/CI e selecione um estande) antes de visualizar os termos.");
    }
  };

  useEffect(() => {
    setIsBrasil(pais === "BR");
  }, [pais]);

  useEffect(() => {
    if (cep === " ") {
      setEndereco(" ");
    }
  }, [cep]);

  const buscarEndereco = async (cepDigitado) => {
    try {
      const resposta = await fetch(`https://viacep.com.br/ws/${cepDigitado}/json/`);
      const dados = await resposta.json();
  
      if (!dados.erro) {
        setEstado(dados.uf);
        setEndereco(`${dados.logradouro}, ${dados.bairro}`);
        setCidade(dados.localidade);
      }
    } catch (error) {
      console.error('Erro ao buscar o CEP:', error);
    }
  };

  const handleCepChange = (e) => {
    const novoCep = e.target.value.replace(/\D/g, '');
    setCep(novoCep);
  
    if (novoCep.length === 8) {
      buscarEndereco(novoCep);
    }
  };

  const getContratoFormatado = () => {
    return contrato || "";
  };

  const validarCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj.length !== 14) return false;

    // Elimina CNPJs invalidos conhecidos
    const cnpjsInvalidos = [
      "00000000000000", "11111111111111", "22222222222222",
      "33333333333333", "44444444444444", "55555555555555",
      "66666666666666", "77777777777777", "88888888888888",
      "99999999999999"
    ];
    
    if (cnpjsInvalidos.includes(cnpj)) return false;

    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0))) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(1))) return false;

    return true;
  };

  const validarEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const validarCampos = () => {
    const newErrors = {};
    let isValid = true;

    // Campos obrigatórios para todos os países
    if (!nome?.trim()) {
      newErrors.nome = "Nome é obrigatório";
      isValid = false;
    }

    if (!pais) {
      newErrors.pais = "País é obrigatório";
      isValid = false;
    }

    if (isBrasil) {
      if (!cnpjCi?.trim()) {
        newErrors.cnpjCi = "CNPJ é obrigatório";
        isValid = false;
      } else if (!validarCNPJ(cnpjCi)) {
        newErrors.cnpjCi = "CNPJ inválido";
        isValid = false;
      }
    } 
 
    if (!email?.trim()) {
      newErrors.email = "E-mail é obrigatório";
      isValid = false;
    } else if (!validarEmail(email)) {
      newErrors.email = "E-mail inválido";
      isValid = false;
    }

    if (!telefone?.trim()) {
      newErrors.telefone = "Telefone é obrigatório";
      isValid = false;
    }

    if (!formaPagamentoId) {
      newErrors.formaPagamentoId = "Forma de pagamento é obrigatória";
      isValid = false;
    }

    if (!condicaoPagamentoId) {
      newErrors.condicaoPagamentoId = "Condição de pagamento é obrigatória";
      isValid = false;
    }

    if (!termos) {
      newErrors.termos = "Você deve aceitar os termos e condições";
      isValid = false;
    }

    // Campos obrigatórios apenas para Brasil
    if (isBrasil) {
      if (!cep?.trim()) {
        newErrors.cep = "CEP é obrigatório";
        isValid = false;
      }
      if (!cidade?.trim()) {
        newErrors.cidade = "Cidade é obrigatória";
        isValid = false;
      }
      if (!estado?.trim()) {
        newErrors.estado = "Estado é obrigatório";
        isValid = false;
      }
      if (!endereco?.trim()) {
        newErrors.endereco = "Endereço é obrigatório";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Atualiza o estado correspondente
    switch(name) {
      case 'nome': setNome(value); break;
      case 'pais': setPais(value); break;
      case 'cnpjCi': setCNPJCi(value); break;
      case 'email': setEmail(value); break;
      case 'telefone': setTelefone(value); break;
      case 'cep': setCep(value); break;
      case 'cidade': setCidade(value); break;
      case 'estado': setEstado(value); break;
      case 'endereco': setEndereco(value); break;
      case 'formaPagamentoId': setFormaPagamentoId(value); break;
      case 'condicaoPagamentoId': setCondicaoPagamentoId(value); break;
      case 'observacao': setObservacao(value); break;
    }

    // Limpa o erro quando o campo é alterado
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleConfirmarReservaComValidacao = (e) => {
    e.preventDefault();
    
    if (!validarCampos()) {
      // toast.error("Por favor, preencha todos os campos obrigatórios corretamente");
      // return;
      exibirAviso("Atenção", "Por favor, preencha todos os campos obrigatórios corretamente antes de prosseguir.");
      return;
    }

    if (isBrasil && cnpjCi && !validarCNPJ(cnpjCi)) {
      setErrors(prev => ({ ...prev, cnpjCi: "Por favor, informe um CNPJ válido para o Brasil." }));
      exibirAviso("Documento Inválido", "O CNPJ informado não é válido.");
      return;
    }
    
    handleConfirmarReserva(e);
  };

  if (!openModal) return null;

  return (
    <>
      <Modal zIndex={5000} style={{ animation: openModal ? "showModal 1s ease" : "none", zIndex: 9999 }} isOpen={openModal} centered>
        <ModalHeader className="bg-light p-2">Reservar Espaço</ModalHeader>
        <Form className="tablelist-form" onSubmit={handleConfirmarReservaComValidacao}>
          <ModalBody>
            <Row className="g-2">
              <Col lg={12}>
                <Label className="form-label">Nome*</Label>
                <Input
                  type="text"
                  className="form-control"
                  name="nome"
                  value={nome}
                  onChange={handleChange}
                  placeholder="Digite seu nome"
                  invalid={!!errors.nome}
                />
                {errors.nome && <div className="text-danger small mt-1">{errors.nome}</div>}
              </Col>
              
              <Col lg={6}>
                <Label className="form-label">País*</Label>
                <Input
                  name="pais"
                  type="select"
                  className="form-select"
                  value={pais}
                  onChange={handleChange}
                  invalid={!!errors.pais}
                >
                  <option value="">Selecione...</option>
                  {paises.map((item) => (
                    <option key={item.id} value={item.sigla}>{item.nome}</option>
                  ))}
                </Input>
                {errors.pais && <div className="text-danger small mt-1">{errors.pais}</div>}
              </Col>
              
              <Col lg={6}>
                <Label className="form-label">{isBrasil ? 'CNPJ*' : 'Código Internacional*'}</Label>
                {isBrasil ? (
                  <InputMask
                    mask="99.999.999/9999-99"
                    className="form-control"
                    name="cnpjCi"
                    value={cnpjCi}
                    onChange={handleChange}
                    placeholder="Digite o CNPJ"
                    invalid={!!errors.cnpjCi}
                  />
                ) : (
                  <Input
                    type="text"
                    className="form-control"
                    name="cnpjCi"
                    value={cnpjCi}
                    onChange={handleChange}
                    placeholder="Digite o Código Internacional"
                  />
                )}
                {errors.cnpjCi && <div className="text-danger small mt-1">{errors.cnpjCi}</div>}
              </Col>
              
              <Col lg={6}>
                <Label className="form-label">E-mail*</Label>
                <Input
                  type="email"
                  className="form-control"
                  name="email"
                  value={email}
                  onChange={handleChange}
                  placeholder="Digite seu email"
                  invalid={!!errors.email}
                />
                {errors.email && <div className="text-danger small mt-1">{errors.email}</div>}
              </Col>
              
              <Col lg={6}>
                <Label className="form-label">Telefone*</Label>
                <InputMask
                  className="form-control"
                  mask="(99) 99999-9999"
                  name="telefone"
                  value={telefone}
                  onChange={handleChange}
                  placeholder="Informe o telefone para contato"
                  invalid={!!errors.telefone}
                />
                {errors.telefone && <div className="text-danger small mt-1">{errors.telefone}</div>}
              </Col>
              
              {isBrasil && (
                <>
                  <div className="items-center" style={{ display: "flex", gap: "3px" }}>
                    <Col lg={6}>
                      <Label className="form-label">CEP*</Label>
                      <Input
                        type="text"
                        className="form-control"
                        name="cep"
                        value={cep}
                        onChange={handleCepChange}
                        placeholder="Digite seu CEP"
                        invalid={!!errors.cep}
                      />
                      {errors.cep && <div className="text-danger small mt-1">{errors.cep}</div>}
                    </Col>

                    <Col lg={6}>
                      <Label className="form-label">Estado*</Label>
                      <Input
                        type="text"
                        className="form-control"
                        name="estado"
                        value={estado}
                        onChange={handleChange}
                        placeholder="Seu Estado"
                        invalid={!!errors.estado}
                      />
                      {errors.estado && <div className="text-danger small mt-1">{errors.estado}</div>}
                    </Col>
                  </div>

                  <div className="items-center" style={{ display: "flex", gap: "3px" }}>
                    <Col lg={6}>
                      <Label className="form-label">Endereço*</Label>
                      <Input
                        type="text"
                        className="form-control"
                        name="endereco"
                        value={endereco}
                        onChange={handleChange}
                        placeholder="Seu Endereço"
                        invalid={!!errors.endereco}
                      />
                      {errors.endereco && <div className="text-danger small mt-1">{errors.endereco}</div>}
                    </Col>

                    <Col lg={6}>
                      <Label className="form-label">Cidade*</Label>
                      <Input
                        type="text"
                        className="form-control"
                        name="cidade"
                        value={cidade}
                        onChange={handleChange}
                        placeholder="Sua cidade"
                        invalid={!!errors.cidade}
                      />
                      {errors.cidade && <div className="text-danger small mt-1">{errors.cidade}</div>}
                    </Col>
                  </div>
                </>
              )}
              
              <div className="items-center" style={{ display: "flex", gap: "3px" }}>
                <Col lg={6}>
                  <Label className="form-label">Forma Pagamento*</Label>
                  <Input
                    name="formaPagamentoId"
                    type="select"
                    className="form-select"
                    value={formaPagamentoId}
                    onChange={handleChange}
                    invalid={!!errors.formaPagamentoId}
                  >
                    <option value="">Selecione...</option>
                    {formasPagamento.map((item) => (
                      <option key={item.id} value={item.id}>{item.nome}</option>
                    ))}
                  </Input>
                  {errors.formaPagamentoId && <div className="text-danger small mt-1">{errors.formaPagamentoId}</div>}
                </Col>
                
                <Col lg={6}>
                  <Label className="form-label">Cond. Pagamento*</Label>
                  <Input
                    name="condicaoPagamentoId"
                    type="select"
                    className="form-select"
                    value={condicaoPagamentoId}
                    onChange={handleChange}
                    invalid={!!errors.condicaoPagamentoId}
                  >
                    <option value="">Selecione...</option>
                    {condicoesPagamento.map((item) => (
                      <option key={item.id} value={item.id}>{item.nome}</option>
                    ))}
                  </Input>
                  {errors.condicaoPagamentoId && <div className="text-danger small mt-1">{errors.condicaoPagamentoId}</div>}
                </Col>
              </div>
              
              {comerciais.length > 0 && (
                <Col lg={12}>
                  <Label className="form-label">Comercial:</Label>
                  <Input
                    name="comercialId"
                    type="select"
                    className="form-select"
                    value={comercialId}
                    onChange={(e) => setComercialId(e.target.value)}
                  >
                    <option value="">Selecione...</option>
                    {comerciais.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.nome}
                      </option>
                    ))}
                  </Input>
                </Col>
              )}
              
              <Col lg={12}>
                <Label className="form-label">Observação</Label>
                <Input
                  type="textarea"
                  className="form-control"
                  name="observacao"
                  rows={4}
                  value={observacao}
                  onChange={handleChange}
                />
              </Col>
              
              <Col lg={12}>
                <div className="form-check">
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    id="termos"
                    name="termos"
                    checked={termos}
                    onChange={(e) => setTermos(e.target.checked)}
                    invalid={!!errors.termos}
                  />
                  <Label className="form-check-label" htmlFor="termos" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <p style={{ marginBottom: "0" }}>Eu aceito os <span style={{ color: "blue", cursor: "pointer"}} onClick={handleOpenTermos}>Termos e Condições*</span></p>
                  </Label>
                  {errors.termos && <div className="text-danger small mt-1">{errors.termos}</div>}
                </div>
              </Col>

              {erroCampoVazio && 
                <Alert color="danger" className="mt-2">
                  {erroCampoVazio}
                </Alert>
              } 
            </Row>
          </ModalBody>

          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button 
                type="button" 
                className="btn btn-light" 
                onClick={() => {
                  setOpenModal(false);
                  limparCampos();
                  setErrors({});
                }}
              >
                Fechar
              </button>
              <button 
                type="submit" 
                className="btn btn-success"
                disabled={isLoading}
              >
                {isLoading ? "Enviando..." : "Confirmar"}
              </button>
            </div>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={openModalTermos} toggle={() => setOpenModalTermos(false)} centered zIndex={5001}>
        <ModalHeader toggle={() => setOpenModalTermos(false)}>Termos e Condições</ModalHeader>
        <ModalBody style={{ overflowY: "auto" }}>
          <div dangerouslySetInnerHTML={{ __html: getContratoFormatado() }} />
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-primary" onClick={() => setOpenModalTermos(false)}>Fechar</button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showModalConfirmado} centered backdrop="static" zIndex={5002}>
        <ModalBody className="text-center">
          <h4 className="mt-3">Solicitação de reserva enviada!</h4>
          <p className="text-muted">Você receberá um email com mais informações.</p>
        </ModalBody>
      </Modal>
    </>
  );
}

export default ModalDeReserva;